import { render, staticRenderFns } from "./StudyType.vue?vue&type=template&id=3739241c&"
import script from "./StudyType.vue?vue&type=script&lang=js&"
export * from "./StudyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports